import { Container } from "react-bootstrap";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const ConfirmExit = ({ setIsWelcome }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const page_theme = useSelector(
    (state) => state.table?.business_Info?.page_layout?.instore?.welcome
  );

  useEffect(() => {
    setIsWelcome(location.pathname);
  });

  // Funzione per tornare alla pagina di accesso
  function goToWelcome() {
    // Ottieni i valori di buid e table_no dai localStorage
    const buid = localStorage.getItem("buid");
    const tableNumber = localStorage.getItem("table_no");

    // Pulisco le informazioni di sessione e locale
    localStorage.clear();
    sessionStorage.clear();

    // Reindirizza l'utente alla pagina di accesso con i valori di buid e table_no
    navigate(`/?buid=${buid}&table_no=${tableNumber}`, { replace: true });
  }

  // Funzione per tornare alla home
  function goToHome() {
    navigate("/home", { replace: true });
  }

  return (
    <>
      <Container
        className="d-flex flex-column justify-content-center align-items-center text-center"
        style={{ height: "86vh" }}>
        <h1 className="text-dark p-5 text-center">Bist du sicher, dass du gehen möchtest?</h1>

        <div className="d-flex flex-column text-center">
          <button
            className={`my-3 btntable  btnCreate fs-${page_theme?.font_size_create_table_btn} font-${page_theme?.font_family_create_table_btn}`}
            style={{
              color: page_theme?.primary_create_table_btn_text_color,
              backgroundColor: page_theme?.primary_create_table_btn_bgcolor
            }}
            onClick={() => {
              goToWelcome();
            }}>
            Seite Verlassen
          </button>

          <button
            className={`btntable  btnCreate fs-${page_theme?.font_size_create_table_btn} font-${page_theme?.font_family_create_table_btn}`}
            style={{
              color: page_theme?.primary_create_table_btn_text_color,
              backgroundColor: page_theme?.primary_create_table_btn_bgcolor
            }}
            onClick={() => {
              goToHome();
            }}>
            Zurück zur Bestellung
          </button>
        </div>
      </Container>
    </>
  );
};

export default ConfirmExit;
